import {
    Button,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material'
import { Stack } from '@mui/system'
import { UnitType, useProduct } from '../../context/product_context'
import { StringField } from '../StringField'
import { CurrencyField } from '../CurrencyField'
import { PorcentageField } from '../PorcentageField'
import { UnitTypeField } from '../UnitTypeField'

export const Step2 = () => {
    const {
        productInfo,
        setProductInfo,
        productErrorInfo,
        setProductErrorInfo,
    } = useProduct()

    return <></>
}
